// Academic Deliverables variant 1006 — "Industry Insights" (Chandigarh LP)
// Carousel section ported from the Chandigarh landing-page IndustryInsights
// organism: centered title + "Get Started" lead CTA over a full-bleed
// background image, followed by a card carousel (source logo, description with
// a red→pink highlight band, stat illustration) — embla on desktop, one-card
// slider on mobile.

export const ACADEMIC_DELIVERABLES_1006_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_hover_image: "",
    meta_alt_image: "",
    meta_description: "",
    meta_priority: 1,
    meta_status: true,
  },

  // Seed rows used by the admin preview when no metadata has been saved yet,
  // so the carousel is visible while editing.
  SEED_METADATA: [
    {
      id: "1",
      meta_image: "",
      meta_hover_image: "",
      meta_alt_image: "Industry insight",
      meta_description:
        "The global online education market is projected to reach {USD 350 billion} by 2030.",
      meta_priority: 1,
      meta_status: true,
    },
    {
      id: "2",
      meta_image: "",
      meta_hover_image: "",
      meta_alt_image: "Industry insight",
      meta_description:
        "Professionals with an online degree report {2x faster} career growth.",
      meta_priority: 2,
      meta_status: true,
    },
    {
      id: "3",
      meta_image: "",
      meta_hover_image: "",
      meta_alt_image: "Industry insight",
      meta_description:
        "India will need {90 million} skilled professionals by 2030.",
      meta_priority: 3,
      meta_status: true,
    },
  ],

  ACADEMIC_DELIVERABLES_1006_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "Industry {Insights}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Wrap the highlighted part in { } e.g. Industry {Insights}",
      required: false,
      defaultValue: "Industry {Insights}",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "highlight_color",
      label: "Title Highlight Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave empty for CU red (#E1473F)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_text",
      label: "CTA Button Text",
      value: "Get Started",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Button Text",
      required: false,
      defaultValue: "Get Started",
    },
    {
      fieldName: "button_text_color",
      label: "CTA Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_background_color",
      label: "CTA Button Background Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave empty for CU red (#E1473F)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "desktop_bg_image",
      label: "Background Image (Desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Background Image (Mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Source Logo (top-left, 88×58)",
      fieldName: "meta_hover_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Source Logo",
    },
    {
      header: "Insight Image (right, 150×150)",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Insight Image",
    },
    {
      header: "Image Alt Text",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Image Alt Text",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder:
        "Wrap the highlighted stat in { } e.g. reach {USD 350 billion} by 2030",
      required: true,
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ],
};
